<script setup lang="ts">
import FormPerguntaResposta from '../components/form-pergunta-resposta.vue'
import { usePerguntaRespostaStore } from '../store/usePerguntaRespostaStore'

definePage({
  meta: {
    navActiveLink: 'admin-perguntaresposta',
    action: 'edit',
    subject: 'perguntaresposta',
  },
})

const store = usePerguntaRespostaStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormPerguntaResposta is-editing />
</template>
